import { IconWrapper } from '../runtime';
export default IconWrapper('audio-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0.5 3.75C0.5 1.67893 2.17893 0 4.25 0H20.75C22.8211 0 24.5 1.67893 24.5 3.75V20.25C24.5 22.3211 22.8211 24 20.75 24H4.25C2.17893 24 0.5 22.3211 0.5 20.25V3.75Z",
      "fill": 'url(#' + props.id + '3370f3ad' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "M18.4996 5.66935C18.4996 5.17675 18.0328 4.81791 17.5568 4.94457L8.083 7.46529C7.59011 7.59644 7.24711 8.04276 7.24727 8.5528L7.24922 15.1465C6.9715 15.153 6.68397 15.2006 6.39779 15.2936C5.11661 15.7099 4.3478 16.8777 4.6806 17.9019C5.01339 18.9261 6.32178 19.419 7.60296 19.0027C8.34216 18.7625 8.91081 18.2722 9.1957 17.7036C9.39048 17.3354 9.4996 16.9123 9.4996 16.4588V9.43074L16.2496 7.62034V13.6462C15.9723 13.6526 15.6852 13.7002 15.3995 13.793C14.1192 14.209 13.3511 15.3766 13.6839 16.4008C14.0167 17.425 15.3243 17.9181 16.6046 17.5022C16.821 17.4318 17.0228 17.3401 17.2071 17.2311C17.3789 17.1309 17.5382 17.0125 17.6819 16.8786C17.8232 16.7477 17.9464 16.6049 18.0488 16.4541C18.3336 16.0415 18.4996 15.5423 18.4996 14.9978V5.66935Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '3370f3ad',
      "x1": "0.5",
      "y1": "-9.15527e-05",
      "x2": "24.5",
      "y2": "23.9999",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#8497B8"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#60718D"
    }
  })])])]);
});